<template>
  <div>
    <NavBar/>
    <Banner/>
    <Info/>
  </div>
</template>
<script>
import NavBar from "./NavBar";
import Banner from "./Banner";
import Info from "./Info";
export default {
  name: 'Hellow',
  data () {
    return {
      
    }
  },
  components:{
    NavBar:NavBar,
    Banner:Banner,
    Info:Info
  },
}
</script>
<style scoped lang="scss" vars="{ zoom }">


</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue